import { DefaultTheme } from "styled-components/native";
import { WarningType } from "./types";

export const getWarningColors = (type: WarningType, theme: DefaultTheme) => {
  switch (type) {
    case WarningType.WARNING:
      return {
        backgroundColor: theme["warn-02"],
        iconColor: theme["warn-01"],
      };
    default:
      return {
        backgroundColor: "transparent",
        iconColor: "transparent",
      };
  }
};
